import React from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import { push } from 'connected-react-router'

export class  TrainingTableComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            count: 5,
            val:'Ausgebucht',
            val1:'Jetzt Buchen',
            disabled:true
        }
        //this.change = this.change.bind(this)

    }

    componentDidMount() {
        setTimeout(() => {
            this.updateCount(this.state.count)
        }, 100);

        setTimeout(() => {
            this.updateCount(this.state.count)
        }, 1000);

        setTimeout(() => {
            this.updateCount(this.state.count)
        }, 2000);

        setTimeout(() => {
            this.updateCount(this.state.count)
        }, 4000);
    }
    change() {
        this.setState({
          val: this.state.val
        })
    }

    updateCount(count) {
        if (!this.refs.grid) return;

        let maxHeight = 'none';

        if (window.matchMedia("(min-width: 1024px)").matches) {
          maxHeight = "" + Math.max(count * 90, 130) + "px";
        }

        this.setState({
            count: count,
            maxHeight: maxHeight
        })

        
    }

    render() {
        const props = this.props;
        const trainings = (props.trainings || []).slice(0, this.state.count)
        return <div ref="grid" className="grid-container" style={{maxHeight: this.state.maxHeight}}>
            <div className="grid white-grid mobile-hidden">
                <div className="col ">
                    <div className="text ">
                        <p><strong>Datum</strong></p>
                    </div>
                </div>
                <div className="col ">
                    <div className="text ">
                        <p><strong>Training</strong></p>
                    </div>
                </div>
                <div className="col ">
                    <div className="text ">
                        <p><strong>Preis</strong></p>
                    </div>
                </div>
                <div className="col ">
                    <div className="text ">
                        <p><strong>Plätze</strong></p>
                    </div>
                </div>
                <div className="col ">
                    <div className="text ">

                    </div>
                </div>
            </div>
            {trainings.map(t => {
                    if(t.freeSlots===0){
                return <div key={t.id}  className="grid white-grid white-grid" style={{color:'gray'}}>
                    <div className="col ">
                        <div className="text ">
                            <p><strong>{moment(t.date).format('DD.MM.YYYY')}</strong></p>
                        </div>
                    </div>
                    <div className="col ">
                        <div className="text ">
                            <p>
                                {props.trainingTypes[t.trainingTypeId].name}
                                &nbsp; {t.offer && <strong className="offer-badge">Angebot</strong>}
                            </p>
                        </div>
                    </div>
                    <div className="col ">
                        <div className="text">
                            <p>{t.price.toFixed(0)} €</p>
                        </div>
                    </div>
                    <div className="col ">
                        <div className="mx-auto" > 
                            <p>Ausgebucht</p>
                        </div>
                    </div>
                    <div id >
                    <div className="col ">
                        <div className="text text-right">
                            <button  className="disabled-btn gray-btn disabled-btn-small" type="button" >Ausgebucht</button>
                        </div>
                    </div>
                    </div>
                </div>
                    }else{
                        return <div key={t.id}  className="grid white-grid white-grid-hover" onClick={() => props.gotoToShop(t.vehicleTypeId, t.trainingTypeId, t.id)}>
                        <div className="col ">
                            <div className="text ">
                                <p><strong>{moment(t.date).format('DD.MM.YYYY')}</strong></p>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="text ">
                                <p>
                                    {props.trainingTypes[t.trainingTypeId].name}
                                    &nbsp; {t.offer && <strong className="offer-badge">Angebot</strong>}
                                </p>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="text">
                                <p>{t.price.toFixed(0)} €</p>
                            </div>
                        </div>
                        <div className="col ">
                            <div className="text ">
                                
                                <p>{t.freeSlots} von {t.slots} Plätzen frei</p>
                            </div>
                        </div>
                        <div id >
                        <div className="col ">
                            <div className="text text-right">
                                <button  className="btn white-btn btn-small" type="button" >Jetzt Buchen</button>
                            </div>
                        </div>
                        </div>
                    </div>
                    }

            
            })}
            {(this.state.count < props.trainings.length) && (
                <p className="text-center">
                    <button className="btn white-btn" type="button" onClick={() => this.updateCount(this.state.count + 5)}>Mehr anzeigen</button>
                </p>
            )}
            {trainings.length == 0 && (
                <div className="grid white-grid">
                    <div className="col ">
                        <div className="text text-center">
                            Planen Sie hier Ihren Termin und melden Sie sich bei uns.
                        </div>
                    </div>
                </div>
            )}
        </div>
    }
}

export default connect(
    (state, props) => {
        return {
            trainings: (state.shop.trainings || [])
                .filter(t => t.vehicleTypeId == props.vehicleType)
                .sort((a,b) => a.date.localeCompare(b.date)),
            trainingTypes: state.shop.trainingTypes,
            vehicleTypes: state.shop.vehicleTypes,
        }
    },
    (dispatch,props) => {
        return {
            gotoToShop: (a,b,c) => dispatch(push("/shop/" + a + "/" + b + "/" + c + "#kalender")),
            onParticipantCountChanged: (participantCount) => {
                dispatch({type: 'ORDER_PARTICIPANT_COUNT_CHANGED', participantCount })
            }
        }
    }
)(TrainingTableComponent)



// WEBPACK FOOTER //
// ./src/components/TrainingTable.jsx